export class NextAction{
    public static SUBMIT_TASK: string = 'submit'
    public static CANCEL_TASK: string = 'cancelled'
    public static APPROVED: string = 'approved'
    public static REJECTED: string = 'rejected'
    
    label:string;
    action:string;

}


// WEBPACK FOOTER //
// /app/src/app/shared/models/next-action.ts